export const eventConfig = {
  // The various types of events, specified in the order in which you wish them to appear
  // If you change them here, you'll also have to update the backend script airtable_sync.py (as of 11/02 this is how we sync with fitpros airtable)
  // to support checkin challenge categories, the backend challenge model also has a hard coded list that must match these slugs.
  // Ultimately, across all whitelabels, an improvement would be to model these on the backend.
  group_event_options : {
    'fitness-class': {
      display: 'Fitness Class',
      slug: 'fitness-class'
    },
    'meditation-class': {
      display: 'Meditation Class',
      slug: 'meditation-class'
    },
    'health-talk': {
      display: 'Health Talk',
      slug: 'health-talk'
    },
    'team-building-session': {
      display: 'Team Building Session',
      slug: 'team-building-session'
    },
    'onsite-mini-wellness-fair': {
      display: 'Onsite Mini Wellness Fair',
      slug: 'onsite-mini-wellness-fair'
    },
    'onsite-wellness-fair': {
      display: 'Onsite Wellness Fair',
      slug: 'onsite-wellness-fair'
    },
    '1-to-1-service': {
      display: '1:1 Service',
      slug: '1-to-1-service'
    },
    'carrier-session': {
      display: 'Carrier Session',
      slug: 'carrier-session'
    }
  },
  
  featured_lozenge_count: 8, // the number of featured lozenges to display on the event list (from the list above)
  default_event_tab: 'virtual', // the default event tab to display on events list.
  virtual_event_subtypes: {}, // subtypes for virtual events (workouts, challenges, etc)

  LOCAL_GROUP_OPTIONS: {}, // no groups

  VIRTUAL_GROUP_OPTIONS: {}, // no groups

  WORKSPACE_ONLY_OPTIONS: {
    'False': {
      display: 'Show all events',
      slug: 'False'
    },
    'True': {
      display: 'Show my company events only',
      slug: 'True'
    }
  },

  VIRTUAL_TIME_OPTIONS:{
    'all': {
      display: 'All Times',
      slug: 'all'
    },
    'all-day': {
      display: 'All-day Events',
      slug: 'all-day'
    }
  }
};
